<template>
  <div class="head-wrap">
      <div class="head-right fr">
        <div class="btn-fullscreen fl mr10" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
            <i class="el-icon-rank ft20"></i>
          </el-tooltip>
        </div>
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <span>{{ $store.state.userInfo.userName }}</span><i class="head-arrow"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>帮助</el-dropdown-item>
            <el-dropdown-item divided  command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
  </div>
</template>

<script>
export default{
  data(){
    return{
      fullscreen:false
    }
  },
  computed:{
    // styleObject(){
    //   return 'border-bottom:3px solid '+this.$store.state.themeColor
    // }
  },
  methods:{
    handleCommand(command){
      if(command == 'loginout'){
          this.$store.commit('loginout');
          this.$router.push('/login');
      }
    },
    // 全屏事件
    handleFullScreen(){
      let element = document.documentElement;
      if(this.fullscreen) {
        if(document.exitFullscreen) {
          document.exitFullscreen();
        }else if(document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }else if(document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        }else if(document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }else{
        if(element.requestFullscreen) {
          element.requestFullscreen();
        }else if(element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
        this.fullscreen = !this.fullscreen;
    }
  }
}
</script>

<style scoped>
.head-wrap{
  height:40px;
  background:#fff;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.12), 0 0 3px 0 rgba(0,0,0,.04);
}
.head-right{
  height:40px;
  line-height:40px;
  margin-right:20px;
}
.user-avator img{
  vertical-align:middle;
  width:50px;
  border-radius:50px;
}
.head-arrow{ display: inline-block; width: 16px; height: 16px; background: url(./images/arrow.png) 0 0 no-repeat; vertical-align: middle; margin-left: 5px;}
</style>
